import { commonService } from '../../_services'
const categoryService = commonService('api/v1/category')

const initialState = {
  all: { items: [] },
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

export const categories = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAll(context: any): Promise<void> {
      context.commit('GET_ALL_REQUEST')
      return categoryService.getAll().then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async addOne(context: any, data: any): Promise<void> {
      context.commit('ADD_REQUEST')

      return categoryService.addOne(data).then((resp) => {
        // Fetch just added data
        categoryService.getOne(resp.data._id).then(singleData => {
          context.commit('ADD_ITEM_SUCCESS', singleData.data)
        })
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async updateOne(context: any, data: any): Promise<void> {
      context.commit('UPDATE_REQUEST')

      return categoryService.updateOne(data).then((resp) => {
        return categoryService.getOne(resp.data._id).then(singleData => {
          context.commit('UPDATE_ITEM_SUCCESS', singleData.data)
          return Promise.resolve(singleData.data)
        })
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async deleteOne(context: any, data: any): Promise<void> {
      context.commit('DELETE_REQUEST')

      return categoryService.deleteOne(data._id).then((resp) => {
        context.commit('DELETE_ITEM_SUCCESS', data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
    async hasRefs(context: any, data: any): Promise<void> {
      context.commit('GET_REQUEST')
      return categoryService.hasRefs(data._id).then((resp) => {
        context.commit('GET_REQUEST_SUCCESS', resp.data)
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
    async importCSV(context: any, file: File): Promise<void> {
      context.commit('CSV_UPLOADING')
      return categoryService.importCSV(file).then((resp) => {
        context.commit('CSV_UPLOAD_FINISHED')
        // Reload list data
        context.dispatch('getAll')
        return Promise.resolve(resp.data)
      }).catch(errorMsg => {
        context.commit('REQUEST_ERROR')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        return Promise.reject(errorMsg)
      })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all = { items: allItems }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    GET_REQUEST(state: any) {
      state.loading = true
    },
    GET_REQUEST_SUCCESS(state: any) {
      state.loading = false
    },
    ADD_REQUEST(state: any) {
      state.loading = true
    },
    UPDATE_REQUEST(state: any) {
      state.loading = true
    },
    DELETE_REQUEST(state: any) {
      state.loading = true
    },
    ADD_ITEM_SUCCESS(state: any, item: any) {
      state.all.items.push(item)
      state.loading = false
    },
    UPDATE_ITEM_SUCCESS(state: any, item: any) {
      state.all.items = state.all.items.map(tmp => {
        return tmp._id === item._id ? item : tmp
      })

      state.loading = false
    },
    CSV_UPLOADING(state: any) {
      state.loading = true
    },
    CSV_UPLOAD_FINISHED(state: any, item: any) {
      state.loading = false
    },
    DELETE_ITEM_SUCCESS(state: any, item: any) {
      const index = state.all.items.indexOf(item)
      state.all.items.splice(index, 1)
      state.loading = false
    },
    REQUEST_ERROR(state: any, error: any) {
      state.loading = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
  },
  getters: {
    canEdit: state => () => {
      return categoryService.canEdit()
    },
    canDelete: state => () => {
      return categoryService.canDelete()
    }
  },
}
